/* ============================================================
   NOIRÉA homepage sections — scripts (vanilla JS, idempotent)
   IO reveals, hero parallax, manifesto scroll-scrub word fill.
   Theme-editor aware (shopify:section:load). Reduced-motion safe.
   ============================================================ */
(function () {
  'use strict';

  /* guard: several sections include this file — run once */
  if (window.__nrScriptsLoaded) return;
  window.__nrScriptsLoaded = true;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- 1. Scroll-triggered reveals (staggered) ---------- */
  var revealObserver = null;
  if (!reducedMotion && 'IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nr-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  }

  function initReveals(root) {
    var reveals = Array.prototype.slice.call(
      (root || document).querySelectorAll('.nr-reveal:not([data-nr-bound]), .nr-mask-reveal:not([data-nr-bound])')
    );
    if (!revealObserver) {
      reveals.forEach(function (el) { el.classList.add('nr-in'); el.setAttribute('data-nr-bound', '1'); });
      return;
    }
    var groups = {};
    reveals.forEach(function (el) {
      var parent = el.parentElement;
      var key = parent ? (parent.dataset.nrGroup || (parent.dataset.nrGroup = String(Math.random()))) : '0';
      groups[key] = groups[key] || [];
      el.style.setProperty('--nr-delay', (groups[key].length * 0.09) + 's');
      groups[key].push(el);
      el.setAttribute('data-nr-bound', '1');
      revealObserver.observe(el);
    });
  }

  /* ---------- 2. Subtle hero parallax ---------- */
  var parallaxBound = false;
  function initParallax() {
    var heroImg = document.querySelector('.nr-hero__img');
    if (!heroImg || reducedMotion || parallaxBound) return;
    parallaxBound = true;
    var ticking = false;
    function heroParallax() {
      var img = document.querySelector('.nr-hero__img');
      if (img) {
        var y = Math.min(window.scrollY, window.innerHeight);
        img.style.transform = 'translateY(' + (-y * 0.05).toFixed(1) + 'px)';
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(heroParallax);
      }
    }, { passive: true });
  }

  /* ---------- 3. Manifesto scroll-scrub word fill ---------- */
  var scrubTargets = [];
  var scrubBound = false;

  function splitManifesto(el) {
    if (el.getAttribute('data-nr-split')) return;
    el.setAttribute('data-nr-split', '1');
    var roseRaw = (el.getAttribute('data-rose-words') || '').toLowerCase();
    var roseWords = roseRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    function isRose(word) {
      var w = word.toLowerCase().replace(/[.,!?;:]+$/, '');
      return roseWords.indexOf(w) !== -1;
    }
    var text = el.textContent.trim().split(/\s+/);
    el.textContent = '';
    var words = [];
    text.forEach(function (w, i) {
      var span = document.createElement('span');
      span.className = 'nr-word' + (isRose(w) ? ' nr-word--rose' : '');
      span.textContent = w;
      el.appendChild(span);
      if (i < text.length - 1) el.appendChild(document.createTextNode(' '));
      words.push(span);
    });
    scrubTargets.push({ el: el, words: words });
    if (reducedMotion) {
      words.forEach(function (w) { w.classList.add('nr-on'); });
    }
  }

  function scrubAll() {
    var vh = window.innerHeight;
    scrubTargets.forEach(function (t) {
      var rect = t.el.getBoundingClientRect();
      var progress = (vh * 0.9 - rect.top) / (vh * 0.55);
      progress = Math.max(0, Math.min(1, progress));
      var lit = Math.round(progress * t.words.length);
      t.words.forEach(function (w, i) {
        w.classList.toggle('nr-on', i < lit);
      });
    });
  }

  function initManifesto(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('.nr-ethos__manifesto')).forEach(splitManifesto);
    if (!scrubBound && !reducedMotion && scrubTargets.length) {
      scrubBound = true;
      var tick = false;
      window.addEventListener('scroll', function () {
        if (!tick) {
          tick = true;
          window.requestAnimationFrame(function () { scrubAll(); tick = false; });
        }
      }, { passive: true });
      scrubAll();
    } else if (scrubTargets.length) {
      scrubAll();
    }
  }

  /* ---------- init ---------- */
  function initAll(root) {
    initReveals(root);
    initParallax();
    initManifesto(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  /* Theme editor: re-init when a section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
